import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchDashboardData = createAsyncThunk(
  "dashboard/fetchDashboardData",
  async (data, { getState, rejectWithValue }) => {
    try {
      const { startDate, endDate } = data || {};
      const url = `${process.env.REACT_APP_BACKEND_URL}/admin/get-dashboard-details`;
      const token = getState().user.user?.token;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          startDate,
          endDate,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getTotalShipmentsData = createAsyncThunk(
  "dashboard/getTotalShipmentsData",
  async (_, { getState, rejectWithValue }) => {
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/admin/get-dashboard-details`;
      const token = getState().user.user?.token;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getShipmentsDataByVolume = createAsyncThunk(
  "dashboard/getShipmentsDataByVolume",
  async (data, { getState, rejectWithValue }) => {
    try {
      const { days = 30 , startDate, endDate } = data || {};

      const formattedStartDate = startDate || "";
      const formattedEndDate = endDate || "";

      let url = `${process.env.REACT_APP_BACKEND_URL}/admin/shipments-by-volume?startDate=${formattedStartDate}&endDate=${formattedEndDate}&days=${days}`;

      const token = getState().user.user?.token;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);





export const getShipmentsByData = createAsyncThunk(
  "dashboard/getShipmentsData",
  async (data, { getState, rejectWithValue }) => {
    try {
      const { startDate, endDate, days = 30 } = data || {};

      const formattedStartDate = startDate || "";
      const formattedEndDate = endDate || "";
      

      const url = `${process.env.REACT_APP_BACKEND_URL}/admin/shipments-by-destination-data?startDate=${formattedStartDate}&endDate=${formattedEndDate}&days=${days}`;

      const token = getState().user.user?.token;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response.data, "response");
      return response?.data;
    } catch (error) {
      console.error("Error fetching shipments data:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getShipmentsDataByValue = createAsyncThunk(
  "dashboard/getShipmentsDataByValue",
  async (data, { getState, rejectWithValue }) => {
    try {
      const { days, startDate, endDate } = data || {};

      const formattedStartDate = startDate || "";
      const formattedEndDate = endDate || "";

      let url = `${process.env.REACT_APP_BACKEND_URL}/admin/shipments-by-value`;

      if (formattedStartDate && formattedEndDate) {
        url += `?startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
      } else {
        url += `?days=${days ? days : 30}`;
      }
      const token = getState().user.user?.token;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getShipmentsDataByDestination = createAsyncThunk(
  "dashboard/getShipmentsDataByDestination",
  async (data, { getState, rejectWithValue }) => {
    try {
      const { startDate, endDate, days = 30 } = data || {};

      const formattedStartDate = startDate || "";
      const formattedEndDate = endDate || "";

      const url = `${process.env.REACT_APP_BACKEND_URL}/admin/shipments-by-destination?startDate=${formattedStartDate}&endDate=${formattedEndDate}&days=${days}`;

      const token = getState().user.user?.token;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response.data, "response");
      return response?.data;
    } catch (error) {
      console.error("Error fetching shipments data:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



export const getShipmentsDataTotal = createAsyncThunk(
  "dashboard/getShipmentsDataDTotal",
  async (data, { getState, rejectWithValue }) => {
    try {
      const { startDate, endDate, days = 30 } = data || {};

      console.log(startDate, endDate, "mmmmm");

      const formattedStartDate = startDate || "";
      const formattedEndDate = endDate || "";

      const url = `${process.env.REACT_APP_BACKEND_URL}/admin/shipments-by-total-data?startDate=${formattedStartDate}&endDate=${formattedEndDate}`;

      console.log(url, '------');
      const token = getState().user.user?.token;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response.data, "response");
      return response?.data;
    } catch (error) {
      console.error("Error fetching shipments data:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const getShipmentsDataByDestinationAndDays = createAsyncThunk(
  "dashboard/getShipmentsDataByDestinationAndDays",
  async (_, { getState, rejectWithValue }) => {
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/admin/shipments-by-destination-and-days`;
      const token = getState().user.user?.token;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchDashboardSummaryCost = createAsyncThunk(
  "dashboard/fetchDashboardSummary",
  async (data, { getState, rejectWithValue }) => {
    try {
      const { startDate, endDate } = data || {};

      const formattedStartDate = startDate || "";
      const formattedEndDate = endDate || "";

      const url = `${process.env.REACT_APP_BACKEND_URL}/admin/shipments-by-total-cost?startDate=${formattedStartDate}&endDate=${formattedEndDate}`; 
      const token = getState().user.user?.token; 

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      return {
        totalRevenue: response?.data.totalRevenue,
        totalCustomerPrice: response?.data.totalCustomerPrice,
        profit: response?.data.profit,
        totalShipments: response?.data?.totalShipments
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Initial state
const initialState = {
  currentMonth: null,
  lastMonth: null,
  totalCarrierCost: null,
  totalCustomerPrice: null,
  profit: null,
  totalShipments: null,
  totalShipmentsCarrierCost: null,
  totalShipmentsCustomerPrice: null,
  totalShipmentsProfit: null,
  totalShipmentsLoading: false,
  allShipments: null,
  status: "idle",
  error: null,
  totalDataInEuro: null,
  shipmentsByVolumeLoading: false,
  shipmentsByValueLoading: false,
  shipmentsByDestinationLoading: false,
  shipmentsByDestinationAndDaysLoading: false,
  shipmentsByVolume: [],
  shipmentsByValue: [],
  shipmentsByDestination: [],
  shipmentsByDestinationAndDays: [],
  shipmentsByData: [],
  shipmentsByDataLoading: [],
  shipmentsByDataTotal: [],
  shipmentsByCost: {
    totalRevenue: null,
    totalCustomerPrice: null,
    profit: null,
    totalShipments: null,
  }
};

// Create Slice
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        const {
          currentMonth = {},
          lastMonth = {},
          totalCarrierCost = 0,
          totalCustomerPrice = 0,
          profit = 0,
          totalShipments = 0,
          serviceMetrics,
        } = action.payload || {};
        state.currentMonth = currentMonth;
        state.lastMonth = lastMonth;
        state.totalCarrierCost = totalCarrierCost;
        state.totalCustomerPrice = totalCustomerPrice;
        state.profit = profit;
        state.totalShipments = totalShipments;
        state.serviceMetrics = serviceMetrics;
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getTotalShipmentsData.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.totalShipmentsLoading = true;
      })
      .addCase(getTotalShipmentsData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.totalShipmentsLoading = false;
        const {
          totalCarrierCost = 0,
          totalCustomerPrice = 0,
          profit = 0,
          totalShipments = 0,
        } = action.payload || {};

        state.totalShipmentsCarrierCost = totalCarrierCost;
        state.totalShipmentsCustomerPrice = totalCustomerPrice;
        state.totalShipmentsProfit = profit;
        state.allShipments = totalShipments;
      })
      .addCase(getTotalShipmentsData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.totalShipmentsLoading = false;
      })
      .addCase(getShipmentsDataByVolume.pending, (state) => {
        state.shipmentsByVolumeLoading = true;
        state.error = null;
      })
      .addCase(getShipmentsDataByVolume.fulfilled, (state, action) => {
        state.shipmentsByVolumeLoading = false;
        state.error = null;
        state.shipmentsByVolume = action.payload;
      })
      .addCase(getShipmentsDataByVolume.rejected, (state, action) => {
        state.shipmentsByVolumeLoading = false;
        state.error = action.payload;
      })
      .addCase(getShipmentsDataByValue.pending, (state) => {
        state.shipmentsByValueLoading = true;
        state.error = null;
      })
      .addCase(getShipmentsDataByValue.fulfilled, (state, action) => {
        state.shipmentsByValueLoading = false;
        state.error = null;
        state.shipmentsByValue = action.payload;
      })
      .addCase(getShipmentsDataByValue.rejected, (state, action) => {
        state.shipmentsByValueLoading = false;
        state.error = action.payload;
      })
      .addCase(getShipmentsDataByDestination.pending, (state) => {
        state.shipmentsByDestinationLoading = true;
        state.error = null;
      })
      .addCase(getShipmentsDataByDestination.fulfilled, (state, action) => {
        state.shipmentsByDestinationLoading = false;
        state.error = null;
        state.shipmentsByDestination = action.payload;
      })
      .addCase(getShipmentsDataByDestination.rejected, (state, action) => {
        state.shipmentsByDestinationLoading = false;
        state.error = action.payload;
      })
      .addCase(getShipmentsDataByDestinationAndDays.pending, (state) => {
        state.shipmentsByDestinationAndDaysLoading = true;
        state.error = null;
      })
      .addCase(
        getShipmentsDataByDestinationAndDays.fulfilled,
        (state, action) => {
          state.shipmentsByDestinationAndDaysLoading = false;
          state.error = null;
          state.shipmentsByDestinationAndDays = action.payload;
        }
      )
      .addCase(
        getShipmentsDataByDestinationAndDays.rejected,
        (state, action) => {
          state.shipmentsByDestinationAndDaysLoading = false;
          state.error = action.payload;
        }
      )
      .addCase(getShipmentsByData.pending, (state) => {
        state.shipmentsByData = true;
        state.error = null;
      })
      .addCase(getShipmentsByData.fulfilled, (state, action) => {
        state.shipmentsByData = false;
        state.error = null;
        state.shipmentsByData = action.payload;
      })
      .addCase(getShipmentsByData.rejected, (state, action) => {
        state.shipmentsByData = false;
        state.error = action.payload;
      })
      .addCase(getShipmentsDataTotal.pending, (state) => {
        state.shipmentsByDataTotal = true;
        state.error = null;
      })
      .addCase(getShipmentsDataTotal.fulfilled, (state, action) => {
        state.shipmentsByDataTotal = false;
        state.error = null;
        state.shipmentsByDataTotal = action.payload;
      })
      .addCase(getShipmentsDataTotal.rejected, (state, action) => {
        state.shipmentsByDataTotal = false;
        state.error = action.payload;
      }) 
       .addCase(fetchDashboardSummaryCost.pending, (state) => {
        state.shipmentsByCost = true;
        state.error = null;
      })
      .addCase(fetchDashboardSummaryCost.fulfilled, (state, action) => {
        state.shipmentsByCost = false;
        state.error = null;
        state.shipmentsByCost = action.payload;
      })
      .addCase(fetchDashboardSummaryCost.rejected, (state, action) => {
        state.shipmentsByCost = false;
        state.error = action.payload;
      });
  },
});

export const { resetState: resetDashboard } = dashboardSlice.actions;
export default dashboardSlice.reducer;
